import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './components/ChatMessageAssistant/ChatMessageAssistant.css';
// import Chat from './components/Chat';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import EmailVerification from './components/EmailVerification';
import ResendVerification from './components/ResendVerification';
import RegistrationSuccess from './components/RegistrationSuccess';
// import SimpleChatTest from './components/SimpleChatTest/SimpleChatTest';
import ChatArtifact from './components/ChatArtifact/ChatArtifact';
import ErrorBoundary from './ErrorBoundary';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Check if user is authenticated
        const token = localStorage.getItem('token');
        setIsAuthenticated(!!token);
        setIsLoading(false);
    }, []);

    // Show nothing while checking authentication
    if (isLoading) {
        return null;
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Render children if authenticated
    return children;
};

// Alle React/JSX-Code muss in dieser Datei stehen
const App = () => {
    return (
        <ErrorBoundary>
            <BrowserRouter
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true
                }}
            >
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/registration-success" element={<RegistrationSuccess />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token/:email" element={<ResetPassword />} />
                    <Route path="/verify-email/:token/:email" element={<EmailVerification />} />
                    <Route path="/resend-verification" element={<ResendVerification />} />
                    {/* <Route path="/chat" element={<SimpleChatTest />} />
                    <Route path="/new" element={<SimpleChatTest />} /> */}
                    <Route path="/" element={
                        <ProtectedRoute>
                            <ChatArtifact />
                        </ProtectedRoute>
                    } />
                </Routes>
            </BrowserRouter>
        </ErrorBoundary>
    );
};

// Render der App
const container = document.getElementById('app');
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
